import { render, staticRenderFns } from "./index12.vue?vue&type=template&id=845aaeb6&scoped=true"
import script from "./index12.vue?vue&type=script&lang=js"
export * from "./index12.vue?vue&type=script&lang=js"
import style0 from "./index12.vue?vue&type=style&index=0&id=845aaeb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845aaeb6",
  null
  
)

export default component.exports